<template>
  <main>
    <PageIntro v-if="appLogin === false"
      :heading="'Register for a <span>My Stoke</span> account'"
      :body="'<p>Enter your details below to create your MyStoke account. One time registration is required with your email (this will be your new login details and replace any existing login details).</p><p>Your MyStoke account will allow you seamless access to the Official Store, Stoke City+, Stoke City+ Live, the Official App and Ticketing.</p>'" />
    <PageIntro v-else
      :heading="'Register for a <span>My Stoke</span> account'"
      :body="''" />
    <Registration />
    <FooterShout v-if="appLogin === false" :type="'signin'"/>
  </main>
</template>

<script>
  import Registration from '@/components/Registration'
  import PageIntro from '@/components/PageIntro'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      Registration,
      PageIntro,
      FooterShout
    },
    data() {
      return {
        appLogin: false
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-register'){
        this.appLogin = true
      }
    },
  }
</script>
